import React from 'react';
import { Link } from "react-router-dom";

import MainComponent from "components/Main";

import './index.less';
import './themes/default.less';

import { ReactComponent as AppointmentIcon } from 'icons/menu/appointment.svg';
import { ReactComponent as ScheduleIcon } from 'icons/menu/schedule.svg';
import { ReactComponent as ClientsIcon } from 'icons/menu/patients.svg';
import { ReactComponent as EmployeesIcon } from 'icons/menu/employees.svg';
import { ReactComponent as TasksIcon } from 'icons/menu/tasks.svg';
import { ReactComponent as ContactsIcon } from 'icons/menu/contacts.svg';
import { ReactComponent as PriceIcon } from 'icons/menu/price.svg';
import { ReactComponent as ReportIcon } from 'icons/menu/report.svg';
import { ReactComponent as ExpensesIcon } from 'icons/menu/expenses.svg';
import { ReactComponent as PermissionsIcon } from 'icons/menu/lock.svg';
import { ReactComponent as SettingsIcon } from 'icons/menu/settings.svg';
import { ReactComponent as EgiszIcon } from 'icons/menu/egisz.svg';

const menuIcons = {
    appointment: AppointmentIcon,
    schedule: ScheduleIcon,
    clients: ClientsIcon,
    employees: EmployeesIcon,
    tasks: TasksIcon,
    contacts: ContactsIcon,
    price: PriceIcon,
    report: ReportIcon,
    expenses: ExpensesIcon,
    permissions: PermissionsIcon,
    egisz: EgiszIcon,
    settings: SettingsIcon,
};

const menuIconsSize = {
    contacts: 24
};

export default class MenuItems extends MainComponent {
    link(to, comp, props = {}) {
        if (to === "price")
            to = "price#id=current";
        return <Link key={to} to={"/" + to} {...props}>{comp}</Link>;
    }

    insertMenuItem(key, value, showLabel) {
        const active = value === key ? " active" : "";
        const Icon = menuIcons[key];
        const size = menuIconsSize[key] || 18;
        const props = { className: `menuItem${active} flex centerV gap8` };
        const label = "menu." + key;

        if (!showLabel)
            props["data-tooltip"] = label;

        return this.link(key, (
            <>
                <div className="icon flex centerAll rad8">
                    <Icon className={`img ${key}`} width={`${size}px`} />
                </div>
                {!!showLabel && (
                    <div className="flex1 text p1SemiBold">{this.tr(label)}</div>
                )}
            </>
        ), props);
    }

    render() {
        const { className, menuItems, showLabel, value } = this.props;
        const items = menuItems.filter(it => this._helper.checkProfilePermissions("pages." + it));

        return (
            <div className={className}>
                {items.map(key => {
                    return this.insertMenuItem(key, value, showLabel);
                })}
            </div>
        );
    }
}
